










import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithDeliveryEditor from '@/components/Delivery/CommonFormWithDeliveryEditor.vue';

const CreateOrder = defineComponent({
  components: {
    CommonFormWithDeliveryEditor,
  },
});

export default CreateOrder;
